import { Component, DestroyRef, inject } from '@angular/core';
import { ICellRendererParams } from "ag-grid-community";
import { Alert } from "../../../../../../models/alerts/alert";
import { observe, Observer } from "fast-json-patch";
import { AlertRecord } from '../../../../../../models/alerts/alert-record';
import { ICellRendererAngularComp } from "ag-grid-angular";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<AlertRecord | Alert> & {
  openAlert: ActionEvent,
}

@Component({
  selector: 'app-ag-alerts-title',
  standalone: true,
  imports: [],
  templateUrl: 'ag-alerts-title.component.html',
  styleUrl: 'ag-alerts-title.component.scss'
})
export class AgAlertsTitleComponent implements ICellRendererAngularComp {
  protected destroyRef = inject(DestroyRef);

  observer!: Observer<Alert[]>;

  protected params!: CellRendererParams;
  title = '';
  message = '';
  alerts!: AlertRecord | Alert;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.params = params;

    if (params.data !== undefined) {
      this.alerts = params.data;
      this.observer = observe(this.alerts);
    }

    this.title = (this.params.value as string) ?? '';
    // this.message = params.data?.['modelDetailTitle'] || params.data?.['model']?.['message'] || '';

    return true;
  }

  openAlert(): void {
    const data = { alertRecord: this.params.data, index: this.params.node.rowIndex };
    this.params.openAlert(data);
  }
}
